module.exports = __webpack_public_path__ + "static/img/tag-icon.7aa2baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/tag-icon.png
// module id = 7tnj
// module chunks = 130